/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as VerifyEmailImport } from './routes/verify-email'
import { Route as TreesImport } from './routes/trees'
import { Route as TeamsImport } from './routes/teams'
import { Route as ShopImport } from './routes/shop'
import { Route as SettingsImport } from './routes/settings'
import { Route as ResetPasswordImport } from './routes/reset-password'
import { Route as RegisterImport } from './routes/register'
import { Route as NotificationsImport } from './routes/notifications'
import { Route as MilestonesImport } from './routes/milestones'
import { Route as LoginImport } from './routes/login'
import { Route as InsightsImport } from './routes/insights'
import { Route as HomeImport } from './routes/home'
import { Route as ForgotPasswordImport } from './routes/forgot-password'
import { Route as ClubsImport } from './routes/clubs'
import { Route as ClubManagementImport } from './routes/club-management'
import { Route as BuddiesImport } from './routes/buddies'
import { Route as AchievementsImport } from './routes/achievements'
import { Route as IndexImport } from './routes/index'
import { Route as ProfilesIndexImport } from './routes/profiles/index'
import { Route as MissionsIndexImport } from './routes/missions/index'
import { Route as StravaExchangetokenImport } from './routes/strava/exchange_token'
import { Route as ProfilesCustomizeImport } from './routes/profiles/customize'
import { Route as MissionsCreateImport } from './routes/missions/create'

// Create/Update Routes

const VerifyEmailRoute = VerifyEmailImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRoute,
} as any)

const TreesRoute = TreesImport.update({
  id: '/trees',
  path: '/trees',
  getParentRoute: () => rootRoute,
} as any)

const TeamsRoute = TeamsImport.update({
  id: '/teams',
  path: '/teams',
  getParentRoute: () => rootRoute,
} as any)

const ShopRoute = ShopImport.update({
  id: '/shop',
  path: '/shop',
  getParentRoute: () => rootRoute,
} as any)

const SettingsRoute = SettingsImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRoute,
} as any)

const ResetPasswordRoute = ResetPasswordImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRoute,
} as any)

const RegisterRoute = RegisterImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRoute,
} as any)

const NotificationsRoute = NotificationsImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => rootRoute,
} as any)

const MilestonesRoute = MilestonesImport.update({
  id: '/milestones',
  path: '/milestones',
  getParentRoute: () => rootRoute,
} as any)

const LoginRoute = LoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const InsightsRoute = InsightsImport.update({
  id: '/insights',
  path: '/insights',
  getParentRoute: () => rootRoute,
} as any)

const HomeRoute = HomeImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => rootRoute,
} as any)

const ForgotPasswordRoute = ForgotPasswordImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRoute,
} as any)

const ClubsRoute = ClubsImport.update({
  id: '/clubs',
  path: '/clubs',
  getParentRoute: () => rootRoute,
} as any)

const ClubManagementRoute = ClubManagementImport.update({
  id: '/club-management',
  path: '/club-management',
  getParentRoute: () => rootRoute,
} as any)

const BuddiesRoute = BuddiesImport.update({
  id: '/buddies',
  path: '/buddies',
  getParentRoute: () => rootRoute,
} as any)

const AchievementsRoute = AchievementsImport.update({
  id: '/achievements',
  path: '/achievements',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const ProfilesIndexRoute = ProfilesIndexImport.update({
  id: '/profiles/',
  path: '/profiles/',
  getParentRoute: () => rootRoute,
} as any)

const MissionsIndexRoute = MissionsIndexImport.update({
  id: '/missions/',
  path: '/missions/',
  getParentRoute: () => rootRoute,
} as any)

const StravaExchangetokenRoute = StravaExchangetokenImport.update({
  id: '/strava/exchange_token',
  path: '/strava/exchange_token',
  getParentRoute: () => rootRoute,
} as any)

const ProfilesCustomizeRoute = ProfilesCustomizeImport.update({
  id: '/profiles/customize',
  path: '/profiles/customize',
  getParentRoute: () => rootRoute,
} as any)

const MissionsCreateRoute = MissionsCreateImport.update({
  id: '/missions/create',
  path: '/missions/create',
  getParentRoute: () => rootRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/achievements': {
      id: '/achievements'
      path: '/achievements'
      fullPath: '/achievements'
      preLoaderRoute: typeof AchievementsImport
      parentRoute: typeof rootRoute
    }
    '/buddies': {
      id: '/buddies'
      path: '/buddies'
      fullPath: '/buddies'
      preLoaderRoute: typeof BuddiesImport
      parentRoute: typeof rootRoute
    }
    '/club-management': {
      id: '/club-management'
      path: '/club-management'
      fullPath: '/club-management'
      preLoaderRoute: typeof ClubManagementImport
      parentRoute: typeof rootRoute
    }
    '/clubs': {
      id: '/clubs'
      path: '/clubs'
      fullPath: '/clubs'
      preLoaderRoute: typeof ClubsImport
      parentRoute: typeof rootRoute
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordImport
      parentRoute: typeof rootRoute
    }
    '/home': {
      id: '/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof HomeImport
      parentRoute: typeof rootRoute
    }
    '/insights': {
      id: '/insights'
      path: '/insights'
      fullPath: '/insights'
      preLoaderRoute: typeof InsightsImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/milestones': {
      id: '/milestones'
      path: '/milestones'
      fullPath: '/milestones'
      preLoaderRoute: typeof MilestonesImport
      parentRoute: typeof rootRoute
    }
    '/notifications': {
      id: '/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof NotificationsImport
      parentRoute: typeof rootRoute
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterImport
      parentRoute: typeof rootRoute
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordImport
      parentRoute: typeof rootRoute
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsImport
      parentRoute: typeof rootRoute
    }
    '/shop': {
      id: '/shop'
      path: '/shop'
      fullPath: '/shop'
      preLoaderRoute: typeof ShopImport
      parentRoute: typeof rootRoute
    }
    '/teams': {
      id: '/teams'
      path: '/teams'
      fullPath: '/teams'
      preLoaderRoute: typeof TeamsImport
      parentRoute: typeof rootRoute
    }
    '/trees': {
      id: '/trees'
      path: '/trees'
      fullPath: '/trees'
      preLoaderRoute: typeof TreesImport
      parentRoute: typeof rootRoute
    }
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailImport
      parentRoute: typeof rootRoute
    }
    '/missions/create': {
      id: '/missions/create'
      path: '/missions/create'
      fullPath: '/missions/create'
      preLoaderRoute: typeof MissionsCreateImport
      parentRoute: typeof rootRoute
    }
    '/profiles/customize': {
      id: '/profiles/customize'
      path: '/profiles/customize'
      fullPath: '/profiles/customize'
      preLoaderRoute: typeof ProfilesCustomizeImport
      parentRoute: typeof rootRoute
    }
    '/strava/exchange_token': {
      id: '/strava/exchange_token'
      path: '/strava/exchange_token'
      fullPath: '/strava/exchange_token'
      preLoaderRoute: typeof StravaExchangetokenImport
      parentRoute: typeof rootRoute
    }
    '/missions/': {
      id: '/missions/'
      path: '/missions'
      fullPath: '/missions'
      preLoaderRoute: typeof MissionsIndexImport
      parentRoute: typeof rootRoute
    }
    '/profiles/': {
      id: '/profiles/'
      path: '/profiles'
      fullPath: '/profiles'
      preLoaderRoute: typeof ProfilesIndexImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/achievements': typeof AchievementsRoute
  '/buddies': typeof BuddiesRoute
  '/club-management': typeof ClubManagementRoute
  '/clubs': typeof ClubsRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/home': typeof HomeRoute
  '/insights': typeof InsightsRoute
  '/login': typeof LoginRoute
  '/milestones': typeof MilestonesRoute
  '/notifications': typeof NotificationsRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/settings': typeof SettingsRoute
  '/shop': typeof ShopRoute
  '/teams': typeof TeamsRoute
  '/trees': typeof TreesRoute
  '/verify-email': typeof VerifyEmailRoute
  '/missions/create': typeof MissionsCreateRoute
  '/profiles/customize': typeof ProfilesCustomizeRoute
  '/strava/exchange_token': typeof StravaExchangetokenRoute
  '/missions': typeof MissionsIndexRoute
  '/profiles': typeof ProfilesIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/achievements': typeof AchievementsRoute
  '/buddies': typeof BuddiesRoute
  '/club-management': typeof ClubManagementRoute
  '/clubs': typeof ClubsRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/home': typeof HomeRoute
  '/insights': typeof InsightsRoute
  '/login': typeof LoginRoute
  '/milestones': typeof MilestonesRoute
  '/notifications': typeof NotificationsRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/settings': typeof SettingsRoute
  '/shop': typeof ShopRoute
  '/teams': typeof TeamsRoute
  '/trees': typeof TreesRoute
  '/verify-email': typeof VerifyEmailRoute
  '/missions/create': typeof MissionsCreateRoute
  '/profiles/customize': typeof ProfilesCustomizeRoute
  '/strava/exchange_token': typeof StravaExchangetokenRoute
  '/missions': typeof MissionsIndexRoute
  '/profiles': typeof ProfilesIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/achievements': typeof AchievementsRoute
  '/buddies': typeof BuddiesRoute
  '/club-management': typeof ClubManagementRoute
  '/clubs': typeof ClubsRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/home': typeof HomeRoute
  '/insights': typeof InsightsRoute
  '/login': typeof LoginRoute
  '/milestones': typeof MilestonesRoute
  '/notifications': typeof NotificationsRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/settings': typeof SettingsRoute
  '/shop': typeof ShopRoute
  '/teams': typeof TeamsRoute
  '/trees': typeof TreesRoute
  '/verify-email': typeof VerifyEmailRoute
  '/missions/create': typeof MissionsCreateRoute
  '/profiles/customize': typeof ProfilesCustomizeRoute
  '/strava/exchange_token': typeof StravaExchangetokenRoute
  '/missions/': typeof MissionsIndexRoute
  '/profiles/': typeof ProfilesIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/achievements'
    | '/buddies'
    | '/club-management'
    | '/clubs'
    | '/forgot-password'
    | '/home'
    | '/insights'
    | '/login'
    | '/milestones'
    | '/notifications'
    | '/register'
    | '/reset-password'
    | '/settings'
    | '/shop'
    | '/teams'
    | '/trees'
    | '/verify-email'
    | '/missions/create'
    | '/profiles/customize'
    | '/strava/exchange_token'
    | '/missions'
    | '/profiles'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/achievements'
    | '/buddies'
    | '/club-management'
    | '/clubs'
    | '/forgot-password'
    | '/home'
    | '/insights'
    | '/login'
    | '/milestones'
    | '/notifications'
    | '/register'
    | '/reset-password'
    | '/settings'
    | '/shop'
    | '/teams'
    | '/trees'
    | '/verify-email'
    | '/missions/create'
    | '/profiles/customize'
    | '/strava/exchange_token'
    | '/missions'
    | '/profiles'
  id:
    | '__root__'
    | '/'
    | '/achievements'
    | '/buddies'
    | '/club-management'
    | '/clubs'
    | '/forgot-password'
    | '/home'
    | '/insights'
    | '/login'
    | '/milestones'
    | '/notifications'
    | '/register'
    | '/reset-password'
    | '/settings'
    | '/shop'
    | '/teams'
    | '/trees'
    | '/verify-email'
    | '/missions/create'
    | '/profiles/customize'
    | '/strava/exchange_token'
    | '/missions/'
    | '/profiles/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AchievementsRoute: typeof AchievementsRoute
  BuddiesRoute: typeof BuddiesRoute
  ClubManagementRoute: typeof ClubManagementRoute
  ClubsRoute: typeof ClubsRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  HomeRoute: typeof HomeRoute
  InsightsRoute: typeof InsightsRoute
  LoginRoute: typeof LoginRoute
  MilestonesRoute: typeof MilestonesRoute
  NotificationsRoute: typeof NotificationsRoute
  RegisterRoute: typeof RegisterRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SettingsRoute: typeof SettingsRoute
  ShopRoute: typeof ShopRoute
  TeamsRoute: typeof TeamsRoute
  TreesRoute: typeof TreesRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
  MissionsCreateRoute: typeof MissionsCreateRoute
  ProfilesCustomizeRoute: typeof ProfilesCustomizeRoute
  StravaExchangetokenRoute: typeof StravaExchangetokenRoute
  MissionsIndexRoute: typeof MissionsIndexRoute
  ProfilesIndexRoute: typeof ProfilesIndexRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AchievementsRoute: AchievementsRoute,
  BuddiesRoute: BuddiesRoute,
  ClubManagementRoute: ClubManagementRoute,
  ClubsRoute: ClubsRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  HomeRoute: HomeRoute,
  InsightsRoute: InsightsRoute,
  LoginRoute: LoginRoute,
  MilestonesRoute: MilestonesRoute,
  NotificationsRoute: NotificationsRoute,
  RegisterRoute: RegisterRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SettingsRoute: SettingsRoute,
  ShopRoute: ShopRoute,
  TeamsRoute: TeamsRoute,
  TreesRoute: TreesRoute,
  VerifyEmailRoute: VerifyEmailRoute,
  MissionsCreateRoute: MissionsCreateRoute,
  ProfilesCustomizeRoute: ProfilesCustomizeRoute,
  StravaExchangetokenRoute: StravaExchangetokenRoute,
  MissionsIndexRoute: MissionsIndexRoute,
  ProfilesIndexRoute: ProfilesIndexRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/achievements",
        "/buddies",
        "/club-management",
        "/clubs",
        "/forgot-password",
        "/home",
        "/insights",
        "/login",
        "/milestones",
        "/notifications",
        "/register",
        "/reset-password",
        "/settings",
        "/shop",
        "/teams",
        "/trees",
        "/verify-email",
        "/missions/create",
        "/profiles/customize",
        "/strava/exchange_token",
        "/missions/",
        "/profiles/"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/achievements": {
      "filePath": "achievements.tsx"
    },
    "/buddies": {
      "filePath": "buddies.tsx"
    },
    "/club-management": {
      "filePath": "club-management.tsx"
    },
    "/clubs": {
      "filePath": "clubs.tsx"
    },
    "/forgot-password": {
      "filePath": "forgot-password.tsx"
    },
    "/home": {
      "filePath": "home.tsx"
    },
    "/insights": {
      "filePath": "insights.tsx"
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/milestones": {
      "filePath": "milestones.tsx"
    },
    "/notifications": {
      "filePath": "notifications.tsx"
    },
    "/register": {
      "filePath": "register.tsx"
    },
    "/reset-password": {
      "filePath": "reset-password.tsx"
    },
    "/settings": {
      "filePath": "settings.tsx"
    },
    "/shop": {
      "filePath": "shop.tsx"
    },
    "/teams": {
      "filePath": "teams.tsx"
    },
    "/trees": {
      "filePath": "trees.tsx"
    },
    "/verify-email": {
      "filePath": "verify-email.tsx"
    },
    "/missions/create": {
      "filePath": "missions/create.tsx"
    },
    "/profiles/customize": {
      "filePath": "profiles/customize.tsx"
    },
    "/strava/exchange_token": {
      "filePath": "strava/exchange_token.tsx"
    },
    "/missions/": {
      "filePath": "missions/index.tsx"
    },
    "/profiles/": {
      "filePath": "profiles/index.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
